<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouvelle caisse"
  (primaryClick)="openCreate(caisseModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Caisse</th>
          <th>UUID</th>
          <th>Entrepôt</th>
          <th>Vendeur</th>
          <th>Statut</th>
          <th style="width: 140px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="6">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement des caisses…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading">
          <td>{{ row.CAISSE }}</td>
          <td><small>{{ row.UUID }}</small></td>
          <td>{{ row.ENTREPOT }}</td>
          <td>{{ row.VENDEUR }}</td>
          <td>
            <span class="badge" [ngClass]="statutBadgeClass(row.STATUT)">{{ row.STATUT }}</span>
          </td>
          <td class="d-flex align-items-center flex-nowrap">
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Modifier"
              [disabled]="isArchived(row)"
              (click)="openEdit(row, caisseModal)"
            >
              <i data-feather="edit" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Paramètres"
              [disabled]="isArchived(row)"
              (click)="openParametres(row)"
            >
              <i data-feather="settings" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-danger"
              title="Archiver"
              [disabled]="isArchived(row)"
              (click)="archiveRow(row)"
            >
              <i data-feather="archive" [size]="16"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="6">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #caisseModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} caisse</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" [formGroup]="form">
    <div class="form-group">
      <label>Entrepôt</label>
      <ng-select
        [items]="entrepotOptions"
        bindLabel="label"
        bindValue="id"
        placeholder="Sélectionner un entrepôt"
        formControlName="entrepot_id"
      ></ng-select>
    </div>
    <div *ngIf="!editId" class="alert alert-light border mb-0">
      <small *ngIf="nextNumeroPreview != null">
        Numéro de caisse attribué automatiquement :
        <strong>n° {{ nextNumeroPreview }}</strong>
      </small>
      <small *ngIf="nextNumeroPreview == null && form.value.entrepot_id" class="text-muted">
        Le numéro sera attribué automatiquement à l'enregistrement.
      </small>
      <small *ngIf="!form.value.entrepot_id" class="text-muted">
        Sélectionnez un entrepôt pour prévisualiser le prochain numéro.
      </small>
    </div>
    <div *ngIf="editId" class="form-group mb-0">
      <label>Numéro de caisse</label>
      <input
        type="number"
        class="form-control"
        formControlName="numero_de_caisse"
        min="1"
      />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">
      Enregistrer
    </button>
  </div>
</ng-template>

<!-- Panneau latéral paramètres (même gabarit que détail ticket POS) -->
<div class="modal-backdrop" *ngIf="showParamPanel" (click)="closeParamPanel()">
  <div class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="caisseParamTitle" (click)="onParamPanelClick($event)">
    <div class="modal-header">
      <h3 id="caisseParamTitle">Paramètres de caisse</h3>
      <button type="button" class="close-btn" aria-label="Fermer" (click)="closeParamPanel()">×</button>
    </div>

    <p class="lc-panel-context mb-0" *ngIf="paramRow">
      <strong>{{ paramRow.CAISSE }}</strong>
      <span> — {{ paramRow.ENTREPOT }}</span>
    </p>

    <div *ngIf="paramLoading" class="lc-panel-loading" role="status" aria-live="polite">
      <span class="spinner-border text-primary spinner-border-sm" aria-hidden="true"></span>
      <p class="mb-0 mt-2">Chargement des paramètres…</p>
    </div>

    <div class="modal-content" *ngIf="!paramLoading">
      <div class="lc-panel-toolbar" *ngIf="paramItems.length > 0">
        <input
          type="search"
          class="form-control form-control-sm lc-panel-toolbar__search"
          placeholder="Rechercher un paramètre…"
          [(ngModel)]="paramSearchTerm"
          [ngModelOptions]="{ standalone: true }"
        />
        <span class="lc-panel-toolbar__stats">{{ activeParamCount }} / {{ paramItems.length }} actifs</span>
        <button type="button" class="btn btn-sm btn-outline-success" (click)="setAllParams(true)">Tout activer</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setAllParams(false)">Tout désactiver</button>
      </div>

      <div *ngIf="paramItems.length === 0" class="lc-panel-empty">
        Aucun paramètre dans le catalogue.
      </div>

      <div *ngIf="paramItems.length > 0 && !hasVisibleParamSections()" class="lc-panel-empty">
        Aucun paramètre ne correspond à votre recherche.
      </div>

      <ng-container *ngIf="hasVisibleParamSections()">
        <div class="section-card" *ngFor="let section of paramSections">
          <ng-container *ngIf="paramSectionItems(section).length > 0">
            <h4 class="section-title-blue">
              <span>{{ section.title }}</span>
              <span>
                <small class="text-muted font-weight-normal mr-50">
                  {{ sectionActiveCount(section) }}/{{ paramSectionItems(section).length }}
                </small>
                <button type="button" class="btn btn-link btn-sm p-0 mr-50" (click)="setSectionParams(section, true)">Tout</button>
                <button type="button" class="btn btn-link btn-sm p-0 text-muted" (click)="setSectionParams(section, false)">Aucun</button>
              </span>
            </h4>
            <div class="lc-param-row" *ngFor="let item of paramSectionItems(section)">
              <span class="lc-param-row__label">{{ item.libelle }}</span>
              <div class="custom-control custom-switch custom-control-success lc-param-row__switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'param_' + item.parametrage_id"
                  [checked]="item.is_active"
                  (change)="item.is_active = $any($event.target).checked"
                />
                <label class="custom-control-label" [for]="'param_' + item.parametrage_id"></label>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="modal-panel__footer">
      <button type="button" class="btn btn-outline-secondary" (click)="closeParamPanel()" [disabled]="paramSaving">Annuler</button>
      <button type="button" class="btn btn-primary" (click)="saveParametres()" [disabled]="paramSaving || paramLoading">
        <span *ngIf="paramSaving" class="spinner-border spinner-border-sm mr-50"></span>
        Enregistrer
      </button>
    </div>
  </div>
</div>
